import styled from 'styled-components';

export const NoMatchContainer = styled.div`
  max-width: 820px;
  margin: 0 auto;
  padding-top: 100px;

  .custom-link {
    font-size: ${({ theme }) => theme.fontSize.xn};
  }

  .custom-navlink {
    text-decoration: none;
    margin-top: 10px;
  }
`;

export const Heading = styled.h3`
  font-size: 34px;
  margin: 32px 0 16px 0;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.limedSpruce};
`;

export const Description = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xn};
  color: ${({ theme }) => theme.colors.regent};
  display: block;
`;

export const LinksContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  line-height: 3;
  margin: 24px 0;
`;
